import type { ScienceInvestment } from '../../types/province';

/**
 * SF-181 Component 1: per-branch ticksRemaining aggregation, extracted from
 * MobileSciencesShell.tsx so it's directly unit-testable (react-refresh/only-export-components
 * blocks named exports from component files — investmentPlanner.ts precedent, same directory).
 *
 * `investments` is a per-tick batch queue (up to 24 entries per branch) — the previous
 * `Math.min(...)` aggregate answered "ticks until the soonest batch lands", which is pinned near
 * a constant (1) under steady-state daily investing and carries no information (CLAUDE.md's
 * SF-140/SF-170 "degenerate-aggregate trap"). `Math.max(...)` answers "ticks until this branch's
 * investment queue is fully drained" — the mathematically correct, informative value.
 */
export function computeBranchTicksRemaining(investments: ScienceInvestment[], branch: string): number {
  const ticks = investments.filter((inv) => inv.scienceType === branch).map((inv) => inv.ticksRemaining);
  if (ticks.length === 0) return 0;
  return Math.max(...ticks);
}
